import { Theme } from "../core/Theme";
import { percent } from "../core/util/Percent";

/**
 * @ignore
 */
export class KtitTheme extends Theme {
	protected setupDefaultRules() {
		super.setupDefaultRules();
        this.rule("Label", ["chart-title"]).setAll({
            fontSize: 18,
            fontWeight: "500",
            textAlign: "center",
            x: percent(50),
            centerX: percent(50),
            paddingTop: 0,
            paddingBottom: 0
        });
        this.rule("Label", ["chart-subtitle"]).setAll({
            fontSize: 14,
            fontWeight: "400",
            textAlign: "center",
            x: percent(50),
            centerX: percent(50)
        });

    }
}